export default "__VITE_ASSET__D7Kjz3cW__"